import { useFetch } from "@/lib/useFetch";

const Bars = ({ title, items, testId }) => {
  const max = Math.max(1, ...items.map((i) => i.total));
  return (
    <div data-testid={testId}>
      <p className="text-[11px] font-bold uppercase tracking-wider text-[#5C6B66] mb-2">{title}</p>
      {items.length === 0 && <p className="text-sm text-[#5C6B66]">—</p>}
      <ul className="space-y-2">
        {items.map((i) => (
          <li key={i.label} className="text-sm">
            <div className="flex justify-between gap-2"><span className="truncate">{i.label}</span><b>{i.total}</b></div>
            <div className="h-2 rounded-full bg-[#F4F1EA] mt-1"><div className="h-2 rounded-full bg-[#B05A40]" style={{ width: `${(i.total / max) * 100}%` }} /></div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const NaoConcluidasResumo = ({ mes }) => {
  const { data } = useFetch(mes ? "/relatorios/nao-concluidas" : null, { mes });
  if (!data) return null;
  return (
    <section className="bg-white rounded-3xl border border-[#E2DDD3] p-5 mb-4 grid sm:grid-cols-[140px_1fr_1fr] gap-5" data-testid="nc-resumo">
      <div className="rounded-2xl bg-[#B05A40] text-white p-4 flex flex-col justify-center">
        <p className="text-[11px] font-bold uppercase tracking-wider opacity-80">Não concluídas</p>
        <p className="font-display text-4xl font-extrabold" data-testid="nc-total">{data.total}</p>
      </div>
      <Bars title="Por motivo" items={data.por_motivo} testId="nc-por-motivo" />
      <Bars title="Por técnico" items={data.por_tecnico.map((t) => ({ label: t.nome, total: t.total }))} testId="nc-por-tecnico" />
    </section>
  );
};
